/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { BusinessObjectDataNotificationRegistration } from '../model/businessObjectDataNotificationRegistration';
import { BusinessObjectDataNotificationRegistrationCreateRequest } from '../model/businessObjectDataNotificationRegistrationCreateRequest';
import { BusinessObjectDataNotificationRegistrationKeys } from '../model/businessObjectDataNotificationRegistrationKeys';
import { BusinessObjectDataNotificationRegistrationSearchRequest } from '../model/businessObjectDataNotificationRegistrationSearchRequest';
import { BusinessObjectDataNotificationRegistrationSearchResponse } from '../model/businessObjectDataNotificationRegistrationSearchResponse';
import { BusinessObjectDataNotificationRegistrationUpdateRequest } from '../model/businessObjectDataNotificationRegistrationUpdateRequest';
import { ErrorInformation } from '../model/errorInformation';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class BusinessObjectDataNotificationRegistrationService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createBusinessObjectDataNotificationRegistration
     * Creates a new business object data notification. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt; &lt;p&gt;Requires READ permission on filter namespace&lt;/p&gt; &lt;p&gt;Requires EXECUTE permission on ALL job action namespaces&lt;/p&gt;
     * @param businessObjectDataNotificationRegistrationCreateRequest the information needed to create the business object data notification
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDataNotificationRegistrationCreateBusinessObjectDataNotificationRegistration(businessObjectDataNotificationRegistrationCreateRequest: BusinessObjectDataNotificationRegistrationCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDataNotificationRegistration>;
    public businessObjectDataNotificationRegistrationCreateBusinessObjectDataNotificationRegistration(businessObjectDataNotificationRegistrationCreateRequest: BusinessObjectDataNotificationRegistrationCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDataNotificationRegistration>>;
    public businessObjectDataNotificationRegistrationCreateBusinessObjectDataNotificationRegistration(businessObjectDataNotificationRegistrationCreateRequest: BusinessObjectDataNotificationRegistrationCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDataNotificationRegistration>>;
    public businessObjectDataNotificationRegistrationCreateBusinessObjectDataNotificationRegistration(businessObjectDataNotificationRegistrationCreateRequest: BusinessObjectDataNotificationRegistrationCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (businessObjectDataNotificationRegistrationCreateRequest === null || businessObjectDataNotificationRegistrationCreateRequest === undefined) {
            throw new Error('Required parameter businessObjectDataNotificationRegistrationCreateRequest was null or undefined when calling businessObjectDataNotificationRegistrationCreateBusinessObjectDataNotificationRegistration.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<BusinessObjectDataNotificationRegistration>(`${this.configuration.basePath}/notificationRegistrations/businessObjectDataNotificationRegistrations`,
            businessObjectDataNotificationRegistrationCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteBusinessObjectDataNotification
     * Deletes an existing business object data notification by key. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param namespace the namespace
     * @param notificationName the business object data notification name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDataNotificationRegistrationDeleteBusinessObjectDataNotification(namespace: string, notificationName: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDataNotificationRegistration>;
    public businessObjectDataNotificationRegistrationDeleteBusinessObjectDataNotification(namespace: string, notificationName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDataNotificationRegistration>>;
    public businessObjectDataNotificationRegistrationDeleteBusinessObjectDataNotification(namespace: string, notificationName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDataNotificationRegistration>>;
    public businessObjectDataNotificationRegistrationDeleteBusinessObjectDataNotification(namespace: string, notificationName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectDataNotificationRegistrationDeleteBusinessObjectDataNotification.');
        }
        if (notificationName === null || notificationName === undefined) {
            throw new Error('Required parameter notificationName was null or undefined when calling businessObjectDataNotificationRegistrationDeleteBusinessObjectDataNotification.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<BusinessObjectDataNotificationRegistration>(`${this.configuration.basePath}/notificationRegistrations/businessObjectDataNotificationRegistrations/namespaces/${encodeURIComponent(String(namespace))}/notificationNames/${encodeURIComponent(String(notificationName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getBusinessObjectDataNotificationRegistration
     * Gets an existing business object data notification by key. &lt;p&gt;Requires READ permission on namespace&lt;/p&gt;
     * @param namespace the namespace
     * @param notificationName the business object data notification name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDataNotificationRegistrationGetBusinessObjectDataNotificationRegistration(namespace: string, notificationName: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDataNotificationRegistration>;
    public businessObjectDataNotificationRegistrationGetBusinessObjectDataNotificationRegistration(namespace: string, notificationName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDataNotificationRegistration>>;
    public businessObjectDataNotificationRegistrationGetBusinessObjectDataNotificationRegistration(namespace: string, notificationName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDataNotificationRegistration>>;
    public businessObjectDataNotificationRegistrationGetBusinessObjectDataNotificationRegistration(namespace: string, notificationName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectDataNotificationRegistrationGetBusinessObjectDataNotificationRegistration.');
        }
        if (notificationName === null || notificationName === undefined) {
            throw new Error('Required parameter notificationName was null or undefined when calling businessObjectDataNotificationRegistrationGetBusinessObjectDataNotificationRegistration.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BusinessObjectDataNotificationRegistration>(`${this.configuration.basePath}/notificationRegistrations/businessObjectDataNotificationRegistrations/namespaces/${encodeURIComponent(String(namespace))}/notificationNames/${encodeURIComponent(String(notificationName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getBusinessObjectDataNotificationRegistrationsByNamespace
     * Gets a list of keys for all existing business object data notification registrations for the specified business object data notification registration namespace.
     * @param namespace the namespace of the business object data notification registration
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDataNotificationRegistrationGetBusinessObjectDataNotificationRegistrationsByNamespace(namespace: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDataNotificationRegistrationKeys>;
    public businessObjectDataNotificationRegistrationGetBusinessObjectDataNotificationRegistrationsByNamespace(namespace: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDataNotificationRegistrationKeys>>;
    public businessObjectDataNotificationRegistrationGetBusinessObjectDataNotificationRegistrationsByNamespace(namespace: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDataNotificationRegistrationKeys>>;
    public businessObjectDataNotificationRegistrationGetBusinessObjectDataNotificationRegistrationsByNamespace(namespace: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectDataNotificationRegistrationGetBusinessObjectDataNotificationRegistrationsByNamespace.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BusinessObjectDataNotificationRegistrationKeys>(`${this.configuration.basePath}/notificationRegistrations/businessObjectDataNotificationRegistrations/namespaces/${encodeURIComponent(String(namespace))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getBusinessObjectDataNotificationRegistrationsByNotificationFilter
     * &lt;p&gt; Gets a list of keys for all existing business object data notification registrations that match the specified business object data notification filter parameters. &lt;/p&gt; &lt;p&gt; This endpoint requires both namespace and name of the business object definition. &lt;/p&gt; &lt;p&gt;Requires READ permission on business object definition namespace&lt;/p&gt;
     * @param businessObjectDefinitionNamespace the namespace of the business object definition
     * @param businessObjectDefinitionName the name of the business object definition
     * @param businessObjectFormatUsage the usage of the business object format
     * @param businessObjectFormatFileType the file type of the business object format
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDataNotificationRegistrationGetBusinessObjectDataNotificationRegistrationsByNotificationFilter(businessObjectDefinitionNamespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage?: string, businessObjectFormatFileType?: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDataNotificationRegistrationKeys>;
    public businessObjectDataNotificationRegistrationGetBusinessObjectDataNotificationRegistrationsByNotificationFilter(businessObjectDefinitionNamespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage?: string, businessObjectFormatFileType?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDataNotificationRegistrationKeys>>;
    public businessObjectDataNotificationRegistrationGetBusinessObjectDataNotificationRegistrationsByNotificationFilter(businessObjectDefinitionNamespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage?: string, businessObjectFormatFileType?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDataNotificationRegistrationKeys>>;
    public businessObjectDataNotificationRegistrationGetBusinessObjectDataNotificationRegistrationsByNotificationFilter(businessObjectDefinitionNamespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage?: string, businessObjectFormatFileType?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (businessObjectDefinitionNamespace === null || businessObjectDefinitionNamespace === undefined) {
            throw new Error('Required parameter businessObjectDefinitionNamespace was null or undefined when calling businessObjectDataNotificationRegistrationGetBusinessObjectDataNotificationRegistrationsByNotificationFilter.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectDataNotificationRegistrationGetBusinessObjectDataNotificationRegistrationsByNotificationFilter.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (businessObjectDefinitionNamespace !== undefined && businessObjectDefinitionNamespace !== null) {
            queryParameters = queryParameters.set('businessObjectDefinitionNamespace', <any>businessObjectDefinitionNamespace);
        }
        if (businessObjectDefinitionName !== undefined && businessObjectDefinitionName !== null) {
            queryParameters = queryParameters.set('businessObjectDefinitionName', <any>businessObjectDefinitionName);
        }
        if (businessObjectFormatUsage !== undefined && businessObjectFormatUsage !== null) {
            queryParameters = queryParameters.set('businessObjectFormatUsage', <any>businessObjectFormatUsage);
        }
        if (businessObjectFormatFileType !== undefined && businessObjectFormatFileType !== null) {
            queryParameters = queryParameters.set('businessObjectFormatFileType', <any>businessObjectFormatFileType);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BusinessObjectDataNotificationRegistrationKeys>(`${this.configuration.basePath}/notificationRegistrations/businessObjectDataNotificationRegistrations`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * searchBusinessObjectDataNotificationRegistrations
     * Retrieves all business object data notification registrations existing in the system per specified search filters and keys. &lt;p&gt;Requires READ permission on namespace&lt;/p&gt;
     * @param businessObjectDataNotificationRegistrationSearchRequest the business object data notification registration search request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDataNotificationRegistrationSearchBusinessObjectDataNotificationRegistrations(businessObjectDataNotificationRegistrationSearchRequest: BusinessObjectDataNotificationRegistrationSearchRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDataNotificationRegistrationSearchResponse>;
    public businessObjectDataNotificationRegistrationSearchBusinessObjectDataNotificationRegistrations(businessObjectDataNotificationRegistrationSearchRequest: BusinessObjectDataNotificationRegistrationSearchRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDataNotificationRegistrationSearchResponse>>;
    public businessObjectDataNotificationRegistrationSearchBusinessObjectDataNotificationRegistrations(businessObjectDataNotificationRegistrationSearchRequest: BusinessObjectDataNotificationRegistrationSearchRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDataNotificationRegistrationSearchResponse>>;
    public businessObjectDataNotificationRegistrationSearchBusinessObjectDataNotificationRegistrations(businessObjectDataNotificationRegistrationSearchRequest: BusinessObjectDataNotificationRegistrationSearchRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (businessObjectDataNotificationRegistrationSearchRequest === null || businessObjectDataNotificationRegistrationSearchRequest === undefined) {
            throw new Error('Required parameter businessObjectDataNotificationRegistrationSearchRequest was null or undefined when calling businessObjectDataNotificationRegistrationSearchBusinessObjectDataNotificationRegistrations.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<BusinessObjectDataNotificationRegistrationSearchResponse>(`${this.configuration.basePath}/notificationRegistrations/businessObjectDataNotificationRegistrations/search`,
            businessObjectDataNotificationRegistrationSearchRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateBusinessObjectDataNotificationRegistration
     * Updates an existing business object data notification by key. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt; &lt;p&gt;Requires READ permission on filter namespace&lt;/p&gt; &lt;p&gt;Requires EXECUTE permission on ALL job action namespaces&lt;/p&gt;
     * @param namespace the namespace
     * @param notificationName the business object data notification name
     * @param businessObjectDataNotificationRegistrationUpdateRequest the information needed to update the business object data notification
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDataNotificationRegistrationUpdateBusinessObjectDataNotificationRegistration(namespace: string, notificationName: string, businessObjectDataNotificationRegistrationUpdateRequest: BusinessObjectDataNotificationRegistrationUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDataNotificationRegistration>;
    public businessObjectDataNotificationRegistrationUpdateBusinessObjectDataNotificationRegistration(namespace: string, notificationName: string, businessObjectDataNotificationRegistrationUpdateRequest: BusinessObjectDataNotificationRegistrationUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDataNotificationRegistration>>;
    public businessObjectDataNotificationRegistrationUpdateBusinessObjectDataNotificationRegistration(namespace: string, notificationName: string, businessObjectDataNotificationRegistrationUpdateRequest: BusinessObjectDataNotificationRegistrationUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDataNotificationRegistration>>;
    public businessObjectDataNotificationRegistrationUpdateBusinessObjectDataNotificationRegistration(namespace: string, notificationName: string, businessObjectDataNotificationRegistrationUpdateRequest: BusinessObjectDataNotificationRegistrationUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectDataNotificationRegistrationUpdateBusinessObjectDataNotificationRegistration.');
        }
        if (notificationName === null || notificationName === undefined) {
            throw new Error('Required parameter notificationName was null or undefined when calling businessObjectDataNotificationRegistrationUpdateBusinessObjectDataNotificationRegistration.');
        }
        if (businessObjectDataNotificationRegistrationUpdateRequest === null || businessObjectDataNotificationRegistrationUpdateRequest === undefined) {
            throw new Error('Required parameter businessObjectDataNotificationRegistrationUpdateRequest was null or undefined when calling businessObjectDataNotificationRegistrationUpdateBusinessObjectDataNotificationRegistration.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<BusinessObjectDataNotificationRegistration>(`${this.configuration.basePath}/notificationRegistrations/businessObjectDataNotificationRegistrations/namespaces/${encodeURIComponent(String(namespace))}/notificationNames/${encodeURIComponent(String(notificationName))}`,
            businessObjectDataNotificationRegistrationUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
